<template>

              
    <div id="incomplete-info-alert" class="alert alert-danger" role="alert" style="text-align: center; display: none">
        Onvolledige bedrijfs informatie - <router-link to="/companies">Vul gegevens in hier</router-link>
    </div>
    <div class="w-100" id="employee-overview">
        <Overview 
            :moduleName="$t('overview.employee_header_2')"
            :moduleNamePlural="$t('overview.employee_header_2')"
            :sort="'first_name'"
            :sortOrder="1"
            :itemService=itemService
            :itemFormRef=itemFormRef
            :showCopy="false"
            :filterGroups=filters
            ref="overview"
        >
            <template #columns>
                <Column field="first_name" :header="$t('overview.name')" :sortable="true">
                    <template #body="slotProps">
                        {{slotProps.data.first_name + (slotProps.data.prefix ? (' ' + slotProps.data.prefix + ' ') : ' ') + slotProps.data.last_name}}
                    </template>
                </Column>
                
                <Column field="amount_of_contracts" header="# contracten" :sortable="true" style="width: 140px"></Column>
                <Column field="employed_since" header="In dienst sinds" :sortable="true" style="width: 250px">
                    <template #body="slotProps">
                        {{ getEmployeeTime(slotProps.data) }}
                    </template>
                </Column>
                <Column field="contract.job_function.fixed_term" header="Contracttype" style="width: 270px">
                    <template #body="slotProps">
                        {{ getEmployeeContractType(slotProps.data) }}
                    </template>
                </Column>
                <Column field="employee_status_id" :header="$t('overview.status')" :sortable="true">
                    <template #body="slotProps">
                        {{ getEmployeeStatus(slotProps.data) }}
                    </template>
                </Column>
            </template>

            <template #form>
                <MailRequestForm ref="ItemForm" :itemData="item" />
            </template>

            <template #modal-footer>
                <!--<button id="nextbutton" type="button" class="btn btn-success" @click.prevent="next">&gt;&ensp;Volgende<span id="nextStep">2</span></button>-->
            </template>
        </Overview>
        <div class="footer-buttons mb-2">
            <button type="button" class="btn secondary-button" @click="openNmbrs">{{ $t('overview.goto', ['NMBRS']) }}&ensp;<i class="fa fa-arrow-up-right-from-square"></i></button>
            <router-link to="/new-employee" class="btn action-button"><i class="fa fa-user-plus"></i>&ensp;{{ $t('form.add', [$t('navigation.employees')]) }}</router-link>
        </div>
        <button id="inv_button" type="button" class="d-none" @click="index"></button>
    </div>
</template>

<script>
import Overview from '@/components/Overview.vue';
import Column from 'primevue/column';
import employeeService from '@/services/EmployeeService';
import MailRequestForm from '@/components/forms/MailRequestForm.vue';
import companyService from '@/services/CompanyService'
import loginservice from '@/services/LoginService'
import store from '@/store/user'
import moment from 'moment'

export default {
    name: 'Employees',
    components: {
        Overview,
        Column,
        MailRequestForm
    },
    data() {
        return {
            item: {},
            itemFormRef: null,
            itemService: employeeService,
            currentCompany: null,
            filters: [
                {
                    name : "Statussen",
                    field: "employee_status_id",
                    type: "checkbox",
                    values: [
                        {id: 1, name: "In dienst"},
                        {id: 2, name: "Uit dienst"},
                        {id: 3, name: "In afwachting van gegevens"},
                        {id: 4, name: "Afwachting contract tekenen"}
                    ]
                },
                {
                    name : "Contracttypes",
                    field: "fixed_term",
                    type: "radio",
                    values: [
                        {id: 0, name: "Onbepaald"},
                        {id: 1, name: "Bepaald"},
                    ]
                }
            ],
            emplymentType: [],
            employeeStatus: []
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$refs.overview.getIndexEmployees(from);
        })
    },
    methods: {
        next() {
            let tabs = document.querySelectorAll("#formModal ul.nav-tabs .nav-link");
        },
        index(){            
            this.$refs.overview.getIndexEmployees();
            this.$refs.overview.resetFilters();
        },
        getEmployeeStatus(data){
            return data.employee_status ? (data.employee_status.name[0].toUpperCase() + data.employee_status.name.substr(1)) : (data.employee_type == 'payroll' ? 'In dienst' : 'Uit dienst');
        },
        getEmployeeTime(data) {
            if (!data.employed_since) return '';

            const start = moment(data.employed_since);
            const now = moment();

            // Handle invalid or future dates gracefully
            if (!start.isValid()) return '';
            if (start.isAfter(now, 'day')) {
                return moment(data.employed_since).format('DD-MM-YYYY') + ' (nog niet in dienst)';
            }

            // Calculate exact elapsed years/months/days sequentially
            const cursor = start.clone();
            const years = now.diff(cursor, 'years');
            cursor.add(years, 'years');

            const months = now.diff(cursor, 'months');
            cursor.add(months, 'months');

            const days = now.diff(cursor, 'days');

            let returnString = '';
            if (years > 0) {
                returnString += years + ' jr';
            }
            if (months > 0) {
                returnString += (returnString ? ' ' : '') + months + ' mnd';
            }
            if (years === 0 && months === 0 && days > 0) {
                returnString += days + ' dag' + (days > 1 ? 'en' : '');
            }
            if (!returnString) {
                returnString = 'vandaag';
            }

            return moment(data.employed_since).format('DD-MM-YYYY') + ' (' + returnString + ')';
        },
        getEmployeeContractType(data){
            if(data.contract_type) {
                return data.contract_type;
            }
            else if(data.contract && data.contract.job_function) {
                if(data.contract.job_function.fixed_term) {
                    return 'Bepaalde tijd (' + moment(data.contract.job_function.fixed_term_expiration_date).format('DD-MM-YYYY') + ')';
                } else {
                    return 'Onbepaalde tijd';
                }
            }
            return '';
        },
        openNmbrs() {
            loginservice.openNmbrs(store.getters.getCurrentCompanyId).then(response => {
                window.open(response.data, '_blank');
            }).catch(error => {
                console.log('error', error)
            });
        }
    },
    mounted() {
        this.itemFormRef = this.$refs.ItemForm;

        // IHR-161. Vlak na inloggen staat het bedrijf nog niet in de store. App.vue
        // heeft daar drie opeenvolgende calls voor nodig (isLoggedIn -> customer ->
        // getCompanies -> setCompany) en dit scherm rendert al voordat die rond zijn.
        // Zonder deze controle ging hier GET /api/company/null de deur uit; die 404
        // had geen .catch en belandde als unhandled rejection in Sentry
        // (IBEO-HR-VUE-4, 397 events sinds september 2024).
        //
        // Overslaan is veilig: setCompany() in App.vue zet dezelfde
        // #incomplete-info-alert zelf ook al, met het bedrijfsobject dat het daar
        // toch al in handen heeft.
        const companyId = store.getters.getCurrentCompanyId;
        if(!companyId){
            return;
        }

        companyService.show(companyId).then(response => {
            const incompleteInfoAlert = document.getElementById('incomplete-info-alert');
            if(incompleteInfoAlert) {
                incompleteInfoAlert.style.display = !response.data.representative_email ? 'block' : 'none';
            }
        }).catch(error => {
            console.log('error', error)
        })
    }
}
</script>